const _excluded = ["handleClickOutside"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
/**
 * @deprecated
 * @see useOnClickOutside
 * import { useOnClickOutside } from '@adsk/alloy-react-helpers';
 */
export default (InnerComponent => {
  /**
   * HOC That handles a component that needs to handle the clickoutside not from within the component
   * for example, look at UserMenu and ModulePicker.
   */
  class ClickOutsideComponent extends Component {
    /**
     * @param props
     */
    constructor(props) {
      super(props);
    }

    /**
     * react-clickoutside uses this as a callback (so it is indeed in use and you can ignore the WebStorm marking)
     */
    handleClickOutside() {
      // This is added to the propTypes of the component when wrapped with onClickOutside as this handler is called by it.
      this.props.handleClickOutside();
    }

    /**
     *
     * @returns {XML}
     */
    render() {
      const _this$props = this.props,
        {
          handleClickOutside
        } = _this$props,
        props = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(InnerComponent, props);
    }
  }
  _defineProperty(ClickOutsideComponent, "propTypes", {});
  ClickOutsideComponent.propTypes = _objectSpread(_objectSpread({}, InnerComponent.propTypes), {}, {
    /**
     * A handler that will be called when the user menu needs to be closed when clicked outside.
     */
    handleClickOutside: PropTypes.func.isRequired
  });
  return onClickOutside(ClickOutsideComponent);
});
//# sourceMappingURL=clickOutsideHOC.js.map